import _ from "lodash";

export const getPageCollectionId = (currentWebsitePage) => {
  if (_.get(currentWebsitePage, "cms.cmsType") === "unicorn") {
    return _.get(currentWebsitePage, "cms.unicorn.collectionId");
  }
  return null;
};
